import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import cx from 'classnames';
import decamelize from 'decamelize';
import { useNavigate } from 'react-router-dom';
import ImagePicker from '@components/@core/ImagePicker';
import { convertUrl, stringToHex } from '~/services/util';
import Body from './Body';
import Logo from '@components/@core/Avatar/Logo';
import Initial from '@components/@core/Avatar/Initial';
import Icon from '@components/@core/Icon';

const Avatar = ({
    className = '',
    isSponsored = false,
    disabled = false,
    initial = null,
    name = undefined,
    slug = null,
    type = 'initial',
    url = undefined,
    size = 'tiny',
    borderColor = 'white',
    borderWidth = 0,
    upload = false,
    icon = '',
    defaultImg = '/images/default.png',
    onDrop = () => {},
    onToggle = () => {},
}) => {
    const navigate = useNavigate();
    const [source, setSource] = useState(convertUrl(url));
    const [open, setOpen] = useState(false);
    const width = decamelize(size, '-');
    const [isImage, setIsImage] = useState(true);
    const handleProfile = () => {
        if (slug) navigate(`/${slug}/about`);
    };

    const handleDrop = (e) => {
        onDrop(e[0]);
        setOpen(true);
        setSource(URL.createObjectURL(e[0]));
    };
    const initials = name ? name?.split(' ').slice(0, -1).join(' ').charAt(0) + name?.split(' ').slice(-1).join(' ').charAt(0) : '';
    useEffect(() => {
        return URL.revokeObjectURL(source);
    }, []);

    useEffect(() => {
        setSource(url);
    }, [url]);

    return upload ? (
        <Dropzone
            className="drag-drop"
            activeClassName="drag-drop active"
            acceptClassName="drag-drop active"
            rejectClassName="drag-drop deactivate"
            //accept="image/*"
            accept={{
                'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp']
            }}
            multiple={false}
            onDrop={handleDrop}
        >
            {({ getRootProps, getInputProps }) => (
                <section>
                    <div className={cx('ds-avatar', width)} {...getRootProps()}>
                        <input {...getInputProps()} />
                        <Body name={name} source={source} borderColor={borderColor} defaultImg={defaultImg} borderWidth={borderWidth} upload={upload} icon={icon} isSponsored={isSponsored} />
                    </div>
                    {type === 'logo' && !disabled && open && <ImagePicker source={source} onApply={setSource} />}
                </section>
            )}
        </Dropzone>
    ) : (
        <div className={cx('ds-avatar', width, className)}>
            {isSponsored ? (
                <div className="ds-avatar-logo" style={{ borderColor, borderWidth, borderStyle: borderWidth > 0 ? 'solid' : 'unset' }} onClick={handleProfile}>
                    <img
                        src={source}
                        width="100%"
                        height="100%"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextElementSibling.classList.remove('hidden');
                        }}
                    />
                    <Initial name={initials} background={stringToHex(name)} upload={upload} hidden={true} />
                </div>
            ) : (
                <Initial name={initials} background={stringToHex(name)} upload={upload} hidden={false} />
            )}

            {!!name && type === 'initial' && (
                <div className="ds-avatar-modal">
                    <div className="dsl-b12 text-400" onClick={onToggle}>
                        {name}
                    </div>
                </div>
            )}
        </div>
    );
};

Avatar.propTypes = {
    className: PropTypes.string,
    isSponsored: PropTypes.bool,
    disabled: PropTypes.bool,
    initial: PropTypes.string,
    url: PropTypes.any,
    name: PropTypes.string,
    slug: PropTypes.string,
    size: PropTypes.oneOf(['extraTiny', 'tiny', 'small', 'regular', 'medium', 'large', 'extraLarge']),
    type: PropTypes.oneOf(['initial', 'logo']),
    upload: PropTypes.bool,
    defaultImg: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.number,
    onDrop: PropTypes.func,
    onToggle: PropTypes.func,
};

export default Avatar;
